// extracted by mini-css-extract-plugin
module.exports = {"item":"CompilationPrevNext_item__sJm2s","image":"CompilationPrevNext_image__1fuM5","text":"CompilationPrevNext_text__bLQ0k"};